import styled from 'styled-components';

export const HeaderWrapper = styled.div`
  padding: var(--spacing-07) var(--spacing-05);
`;

export const InfoBlockWrapper = styled.div``;
